export default __webpack_public_path__ + "static/media/Distribution of Attacks Among Fintech.ffc00783.PNG";